module.exports = __webpack_public_path__ + "static/media/masterthesis_02.8d082b1c.jpg";